import React, { useState } from "react";
import styles from "./styles.module.scss";
import BulkAction from "./bulk-action";
import Pagination from "../../../components/Pagination/Pagination";
import Table from './table';
import MCCCard from './mcc-card';
import SkeletonLoader from "../../../components/skeleton-loader";
import useMccStore from "../../../stores/mcc";

const List = ({
  setPage,
  getMCCList,
  page,
  pageCount,
  dataLoading = false,
}) => {
  const mccList = useMccStore((state) => state.mccList);
  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const totalItems = useMccStore((state) => state.totalItems);
  const itemsPerPage = useMccStore((state) => state.itemsPerPage);
  const handlePage = (pageValue) => {
    setPage(pageValue.selected + 1);
  };

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.desktop_table_wrapper}>
          <Table
            data={mccList}
            fetchData={getMCCList}
            dataLoading={dataLoading}
          />
        </div>
        <div className={styles.mobile_cards_container}>
          {dataLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <div key={`skeleton-${index}`} className={styles.mobile_card_skeleton}>
                <div className={styles.mobile_card_left}>
                  <SkeletonLoader
                    variant="rectangular"
                    width="32px"
                    height="32px"
                    style={{ borderRadius: "4px" }}
                  />
                  <div className={styles.mobile_card_info}>
                    <SkeletonLoader variant="text" width="120px" height="16px" />
                    <SkeletonLoader variant="text" width="80px" height="14px" />
                  </div>
                </div>
                <div className={styles.mobile_card_right}>
                  <SkeletonLoader variant="text" width="70px" height="16px" />
                  <SkeletonLoader
                    variant="rectangular"
                    width="16px"
                    height="16px"
                    style={{ borderRadius: "4px" }}
                  />
                </div>
              </div>
            ))
          ) : !mccList?.length ? (
            <div className={styles.noData}>No data to display</div>
          ) : (
            mccList.map((item, index) => (
              <MCCCard key={item.id ?? index} data={item} fetchData={getMCCList} />
            ))
          )}
        </div>
        {totalItems > 0 && (
          <div className={styles.pagination}>
            <Pagination
              pageCount={pageCount}
              currentPage={page - 1}
              onPageChange={handlePage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
            />
          </div>
        )}
      </div>
      {!!selectedMcc.length && <BulkAction
        fetchData={getMCCList}
      />}
    </div>
  );
};

export default List;
